export const animes = {
  Movies: [
    {
      name: "Your Name",
      japanese: "Kimi no Na wa",
      rating: "8.9",
      links: ""
    },
    {
      name: "I Want to Eat Your Pancreas",
      japanese: "Kimi no Suizō o Tabetai",
      rating: "8.7",
      links: ""
    },
    {
      name: "Weathering with you",
      japanese: "Tenki no Ko",
      rating: "8.5",
      links: ""
    },
    {
      name: "A Silent Voice",
      japanese: "Koe no Katachi",
      rating: "9.2",
      links: ""
    }
  ],
  Fantasy: [
    { name: "Naruto", japanese: "Naruto", rating: "9.5", links: "" },
    {
      name: "Jujutsu Kaisen",
      japanese: "Jujutsu Kaisen",
      rating: "8.6",
      links: ""
    },
    { name: "One Piece", japanese: "One Piece", rating: "8.9", links: "" },
    {
      name: "Darling in the Franxx",
      japanese: "Koe no Katachi",
      rating: "8",
      links: ""
    }
  ],
  Miscellaneous: [
    { name: "Death Note", japanese: "Kimi no Na wa", rating: "9", links: "" },
    {
      name: "Demon Slayer",
      japanese: "Kimetsu no Yaiba",
      rating: "8.9",
      links: ""
    },
    {
      name: "Tokyo Revengers",
      japanese: "Tenki no Ko",
      rating: "8.1",
      links: ""
    },
    {
      name: "Your Lie in April",
      japanese: "Shigatsu wa Kimi no Uso",
      rating: "8.6",
      links: ""
    }
  ]
};
